"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelationshipToPolicyHolderType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var RelationshipToPolicyHolderType_Factory = /** @class */ (function () {
    function RelationshipToPolicyHolderType_Factory() {
    }
    RelationshipToPolicyHolderType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    RelationshipToPolicyHolderType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return RelationshipToPolicyHolderType_Factory;
}());
exports.RelationshipToPolicyHolderType_Factory = RelationshipToPolicyHolderType_Factory;
